import { MaskedLines, Reveal, Overline } from "./shared";

const STEPS = [
    { n: "01", title: "Imagine", desc: "Tell us what you want your space to feel like." },
    { n: "02", title: "Design", desc: "We develop the concept, movement, lighting and visual language." },
    { n: "03", title: "Engineer", desc: "Our technology makes the concept physically possible." },
    { n: "04", title: "Experience", desc: "We install, commission and bring the space to life." },
];

export const Process = () => (
    <section id="about" data-testid="process-section" className="relative py-32 md:py-48">
        <div className="mx-auto max-w-[1600px] px-6 md:px-12">
            <Overline>How It Works</Overline>
            <h2 className="mt-10 font-display text-4xl font-bold uppercase leading-[0.95] tracking-tight sm:text-6xl lg:text-7xl">
                <MaskedLines lines={["A simple journey,", "not a specification."]} />
            </h2>
            <div className="mt-24 grid gap-px bg-white/10 md:grid-cols-2 xl:grid-cols-4">
                {STEPS.map((s, i) => (
                    <Reveal key={s.n} delay={i * 0.1} className="group relative bg-[#070708] p-10 md:p-12">
                        <span className="font-mono-tech text-[11px] tracking-[0.4em] text-white/30 transition-colors duration-700 group-hover:text-[#FFE8B6]/80">
                            {s.n}
                        </span>
                        <h3 className="mt-16 font-display text-3xl font-bold uppercase tracking-tight text-white md:mt-24 md:text-4xl">
                            {s.title}
                        </h3>
                        <p className="mt-6 text-base font-light leading-relaxed text-white/55">{s.desc}</p>
                        <span className="mt-10 block h-px w-0 bg-white/40 transition-[width] duration-700 ease-[cubic-bezier(0.16,1,0.3,1)] group-hover:w-full" />
                    </Reveal>
                ))}
            </div>
        </div>
    </section>
);
